import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    containsHTML: string;
    interactive: string;
    web: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Media-type chip shown on a thumbnail for an interactive-eligible asset */
            containsHTML: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InteractiveLabel.containsHTML?c=2hqzzg55p0ywd", defaultMessage: "Contains HTML" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Media-type chip shown on a thumbnail for an interactive asset */
            interactive: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InteractiveLabel.interactive?c=tmf76ocgxscc", defaultMessage: "Interactive" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Media-type chip shown on a thumbnail for a live web URL asset */
            web: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InteractiveLabel.web?c=19ocytbz8ax0y", defaultMessage: "Web" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
